<template>
  <div class="register2-content">
    <AlertMessages />
    <form @submit.prevent="createAccount">
      <div class="form-row">
        <div class="col-12">
          <div class="field-wrapper select-field-4" v-flyout>
            <select
              id="role"
              v-model="Role"
              @change="onChangeRole($event)"
              :class="{ 'is-invalid': $v.Role.$error }"
              @blur="$v.Role.$touch()"
              ><option
                v-for="option in roles"
                :key="option.value"
                :value="option.value"
                >{{ option.value }}</option
              >
            </select>
            <div class="field-placeholder" v-animate>
              <span class="asterisk">Role</span>
            </div>
          </div>
          <i
            v-if="!$v.Role.$error && this.Role != null"
            class="fa fa-check"
          ></i>
          <div v-if="$v.Role.$error" class="feedback">
            <span v-if="!$v.Role.required">This field is required</span>
          </div>
        </div>
      </div>

      <div v-if="this.Role === 'Other - please give details'">
        <div class="form-row">
          <div class="col-12">
            <div class="field-wrapper" v-flyout>
              <input
                class="text-field-4"
                id="typeOfRole"
                v-model="TypeOfRole"
                @blur="$v.TypeOfRole.$touch()"
                :class="{ 'is-invalid': $v.TypeOfRole.$error }"
                ref="typeOfRoleDetails"
              />
              <i class="fa fa-check"></i>
              <div class="field-placeholder" v-animate>
                <span class="asterisk">Type of role</span>
              </div>
            </div>
            <div v-if="$v.TypeOfRole.$error" class="feedback">
              <span v-if="!$v.TypeOfRole.maxLength"
                >Type of role must be less than 100 characters</span
              >
              <span v-if="!$v.TypeOfRole.characters"
                >Characters and alphabets, hyphens and numbers are allowed</span
              >
            </div>
          </div>
        </div>
      </div>      

      <div class="form-row">
        <div class="col-12">
          <div class="field-wrapper select-field-4" v-flyout>
            <select
              id="organ"
              v-model="Organisation"
              @change="onChangeOrganisation($event)"
              :class="{ 'is-invalid': $v.Organisation.$error }"
              @blur="$v.Organisation.$touch()"
              ><option
                v-for="option in organisations"
                :key="option.value"
                :value="option.value"
                >{{ option.value }}</option
              >
            </select>
            <div class="field-placeholder" v-animate>
              <span class="asterisk">Organisation</span>
            </div>
          </div>
          <i
            v-if="!$v.Organisation.$error && this.Organisation != null"
            class="fa fa-check"
          ></i>
          <div v-if="$v.Organisation.$error" class="feedback">
            <span v-if="!$v.Organisation.required">This field is required</span>
          </div>
        </div>
      </div>

      <div v-if="this.Organisation === 'Other - please give details'">
        <div class="form-row">
          <div class="col-12">
            <div class="field-wrapper" v-flyout>
              <input
                class="text-field-4"
                id="typeOfOrganisation"
                v-model="TypeOfOrganisation"
                @blur="$v.TypeOfOrganisation.$touch()"
                :class="{ 'is-invalid': $v.TypeOfOrganisation.$error }"
                ref="typeOfOrganisationDetails"
              />
              <i class="fa fa-check"></i>
              <div class="field-placeholder" v-animate>
                <span class="asterisk">Type of organisation</span>
              </div>
            </div>
            <div v-if="$v.TypeOfOrganisation.$error" class="feedback">
              <span v-if="!$v.TypeOfOrganisation.maxLength"
                >Type of organisation must be less than 100 characters</span
              >
              <span v-if="!$v.TypeOfOrganisation.characters"
                >Characters and alphabets, hyphens and numbers are allowed</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <div class="field-wrapper select-field-4" v-flyout>
            <select
              id="referral"
              v-model="HowDidYouHearAboutUs"
              @blur="$v.HowDidYouHearAboutUs.$touch()"
              ><option
                v-for="option in referrals"
                :key="option.value"
                :value="option.value"
                >{{ option.value }}</option
              >
            </select>

            <div class="field-placeholder" v-animate>
              <span>How did you hear about us?</span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="keep">
          <p class="keep-title">Keep up to date with the CPSU</p>
          <p class="label-info">
            We would like to keep you informed about our latest resources, news, guidance and training that may be relevant to you. Please let us know whether you’re happy to receive our emails:
          </p>
          <div class="form-row">
            <label class="checkbox checkbox-email label-info" for="emailOptIn"><div>
              Yes I would like to receive emails.
              <input
                type="checkbox"
                class="label-info"
                id="emailOptIn"
                v-model="EmailOptIn"/>

              <span class="checkmark"></span
            ></div></label>
          </div>
        </div>
      </div>

      <div class="form-row">
        <label class="checkbox checkbox-policy label-info" for="policy">
          <div>
            I have read and accepted the
            <a
              target="_blank"
              href="https://thecpsu.org.uk/terms-and-conditions/"
              class="active"
            >
              Terms and conditions
            </a>
            and
            <a
              target="_blank"
              href="https://thecpsu.org.uk/privacy-policy/"
              class="active"
            >
              Privacy policy.</a
            ><span class="asterisk"></span>
          </div>
          
          <input type="checkbox" id="policy" v-model="TermsOfUseAccepted" />
          <span class="checkmark"></span>
        </label>
        <div v-if="$v.TermsOfUseAccepted.$error" class="feedback">
          <span v-if="!$v.TermsOfUseAccepted.required"
            >This field is required</span
          >
        </div>
      </div>

      <div class="form-row cta-group flex-column-reverse flex-md-row">
        <router-link
          role="navigation"
          class="back-link"
          :to="{ name: 'register' }"
          @click.native="GoToStep1()"
        >
          <span class="angle-left-green"></span>
          Back to account info
        </router-link>
        <!-- <router-link
        class="cta-white-203"
        :to="{ name: 'register' }"
        
      >
        Create account
      </router-link> -->
        <button role="button" class="cta-white-203">
          Create account<span class="angle-right-white"></span>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import AlertMessages from "../components/alert-messages";
import { SET_USER } from "../store/mutation-types";

// characters and alphabets, hyphens and numbers only
const characters = helpers.regex(
  "characters",
  /^[0-9a-zA-Z\u00C0-\u024F\u1E02-\u1EF3'\- ]+$/
);

export default {
  name: "RegisterStep2",
  components: { AlertMessages },
  validations: {
    JobTitle: {
      maxLength: maxLength(100),
      characters
    },

    Role: {
      required
    },
    TypeOfRole: {
      customValidation(value, vm) {
        if (vm.Role === "Other - please give details") {
          return value.length > 0;
        }
        return true;
      }
    },
    TypeOfOrganisation: {
      customValidation(value, vm) {
        if (vm.Organisation === "Other - please give details") {
          return value.length > 0;
        }
        return true;
      }
    },
    Organisation: {
      required
    },
    TermsOfUseAccepted: {
      required(val) {
        return val;
      }
    }
  },
  data() {
    return {
      referrals: [],
      roles: [],
      organisations: []
    };
  },

  async created() {
    await this.getContent();
    if (this.content.Roles)
      this.roles = this.content.Roles.map(x => {
        return { value: x };
      });
    if (this.content.Organisations)
      this.organisations = this.content.Organisations.map(x => {
        return { value: x };
      });
    if (this.content.HowDidYouHearAboutUs)
      this.referrals = this.content.HowDidYouHearAboutUs.map(x => {
        return { value: x };
      });
  },
  computed: {
    ...mapGetters("users", ["getUserById"]),
    ...mapState("users", ["user"]),
    ...mapGetters("alert", ["hasError"]),
    ...mapState("util", ["content"]),
    RegistrationStatus: {
      get() {
        return this.user.RegistrationStatus;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { RegistrationStatus: val });
      }
    },
    Id: {
      get() {
        return this.user.Id;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Id: val });
      }
    },
    Role: {
      get() {
        return this.user.Role;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Role: val });
      }
    },
    TypeOfRole: {
      get() {
        return this.user.TypeOfRole;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { TypeOfRole: val });
      }
    },
    Organisation: {
      get() {
        return this.user.Organisation;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { Organisation: val });
      }
    },
    TypeOfOrganisation: {
      get() {
        return this.user.TypeOfOrganisation;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { TypeOfOrganisation: val });
      }
    },
    HowDidYouHearAboutUs: {
      get() {
        return this.user.HowDidYouHearAboutUs;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { HowDidYouHearAboutUs: val });
      }
    },
    TermsOfUseAccepted: {
      get() {
        let val = this.user.TermsOfUseAccepted;
        if (val == undefined) val = false;
        return val;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { TermsOfUseAccepted: val });
      }
    },
    EmailOptIn: {
      get() {
        let val = this.user.EmailOptIn;
        if (val == undefined) val = false;
        return val;
      },
      set(val) {
        this.$store.commit(`users/${SET_USER}`, { EmailOptIn: val });
      }
    }
  },
  methods: {
    ...mapActions("users", ["createUser"]),
    ...mapActions("util", ["getContent"]),
    ...mapActions("alert", ["clear"]),
    onChangeRole(event) {
      this.Role = event.target.value;
       if (this.Role !== "Other - please give details") {
         this.TypeOfRole = null;
       } else {
         this.$nextTick(() => this.$refs.typeOfRoleDetails.focus());
       }
    },
    onChangeOrganisation(event) {
      this.Organisation = event.target.value;
       if (this.Organisation !== "Other - please give details") {
         this.TypeOfOrganisation =null;
       } else {
         this.$nextTick(() => this.$refs.typeOfOrganisationDetails.focus());
       }
    },
    async createAccount() {
      this.clear();
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.RegistrationStatus = 3;
      await this.createUser({
        user: this.user,
        regStatus: this.RegistrationStatus
      });
      if (!this.hasError) {
        this.$emit("setVerification", true);
      }
    },
    GoToStep1() {
      this.$emit("clicked", "0");
    }
  }
};
</script>

<style></style>
